import { LogManager } from '../../../../common/port/log/log.manager.port';
import { CalendarChartAllTimeAveragesAggregateRootMapper } from '../../../../infrastructure/mappers/calendar/all-time-averages/calendar-chart-all-time-averages-aggregate-root.mapper';
import { GetCalendarAppChartAllTimeAveragesRequestDto } from '../../../dtos/calendar/all-time-averages/get-calendar-chart-app-all-time-averages.request.dto';
import { GetCalendarChartAllTimeAveragesResponseDto } from '../../../dtos/calendar/all-time-averages/get-calendar-chart-all-time-averages.response.dto';
import { GetCalendarAppChartAllTimeAveragesQuery } from '../../../queries/calendar/all-time-averages/get-calendar-app-chart-all-time-averages.query';

export class GetCalendarAppChartAllTimeAveragesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetCalendarAppChartAllTimeAveragesQuery,
    protected readonly mapper: CalendarChartAllTimeAveragesAggregateRootMapper
  ) {}

  async get(
    props: GetCalendarAppChartAllTimeAveragesRequestDto
  ): Promise<GetCalendarChartAllTimeAveragesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetCalendarChartAllTimeAveragesController.get encountered an error ${error}`
      );
    }
  }
}
